import { Component, inject, input, output } from '@angular/core';
import { MediaService } from '../../services/media.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-image-uploader',
  imports: [CommonModule],
  templateUrl: './image-uploader.component.html',
  styleUrl: './image-uploader.component.css'
})
export class ImageUploaderComponent {
  userId = input<string | undefined>(undefined);
  orgCode = input<string | undefined>(undefined);
  uploadDone = output<void>();
  files: File[] = [];
  results: any[] = [];
  uploading = false;
  progress = 0;
  mediaSvc = inject(MediaService);

  constructor() {}

  onFilesSelected(evt: Event) {
    const input = evt.target as HTMLInputElement;
    this.files = Array.from(input.files || []);
  }

  upload() {
    if (!this.files.length) return;
    this.uploading = true;
    this.progress = 0;
    this.mediaSvc.uploadBatch(this.files, this.userId()!, this.orgCode()!)
      .subscribe({
        next: batch => {
          this.results = batch;
          this.progress = this.files.length;
        },
        error: err => console.error(err),
        complete: () => {
          this.uploading = false
          this.uploadDone.emit();}
      });
  }
}
